(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('DocumentRequirementFormController', DocumentRequirementFormController);

  /* ngInject */
  function DocumentRequirementFormController($state, $stateParams, $window, Flash, Upload, assessmentService, config, contractService, documentRequirementService, sessionService, vmsProductService, vmsUserService, vendorService) {
    const vm = this;

    vm.branch = {};
    vm.config = config;
    vm.documentRequirement = {};
    vm.id = $stateParams.id;
    vm.resource = {};
    vm.resourceId = $stateParams.resourceId;
    vm.resourceType = $stateParams.resourceType;
    vm.saveDocumentRequirement = saveDocumentRequirement;
    vm.sessionService = sessionService;
    vm.users = [];
    vm.vendor = {};
    vm.vendorId = $stateParams.vendorId;

    $window.bsCustomFileInput.init();

    activate();

    function activate() {
      if (vm.id) {
        getDocumentRequirement();
      } else {
        vm.documentRequirement = {
          resource_id: vm.resourceId,
          resource_type: vm.resourceType,
          has_expiration: false
        };
      }

      getResource();
      getUsers();
    }

    function getDocumentRequirement() {
      documentRequirementService(sessionService.getAuthToken()).get({ resourceType: vm.resourceType, resourceId: vm.resourceId, id: vm.id }, response => {
        vm.documentRequirement = angular.fromJson(angular.toJson(response));
      });
    }

    function getUsers() {
      vmsUserService(sessionService.getAuthToken()).query(response => vm.users = response);
    }

    function getResource() {
      if (vm.resourceType == 'vendors') {
        vendorService(sessionService.getAuthToken()).get({ id: vm.resourceId }, response => vm.resource = response);
      } else if (vm.resourceType == 'contracts') {
        contractService(sessionService.getAuthToken()).get({ id: vm.resouceId }, response => vm.resource = response);
      } else if (vm.resourceType == 'products') {
        vendorService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.vendor = response);
        vmsProductService(sessionService.getAuthToken()).get({ vendorId: vm.vendorId, id: vm.resourceId }, response => vm.resource = response); 
      } else if (vm.resourceType == 'assessments') {
        assessmentService(sessionService.getAuthToken()).get({ id: vm.resourceId }, response => vm.resource = response);
      }
    }

    function saveDocumentRequirement() {
      if (vm.id) {
        let documentUpload = Upload.upload({
          url: `${config.vmsApiEndpoint}/api/${vm.resourceType}/${vm.resourceId}/document_requirements/${vm.id}`,
          method: 'PUT',
          data: { document_requirement: vm.documentRequirement },
          headers: {
            'Authorization': `Token token=${sessionService.getAuthToken()}`
          }
        });

        documentUpload.then(response => {
          showDetailState(response);
          Flash.create('success', 'Document requirement successfully updated.');
        },
        _ => {
          Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
        });
      } else {
        let documentUpload = Upload.upload({
          url: `${config.vmsApiEndpoint}/api/${vm.resourceType}/${vm.resourceId}/document_requirements`,
          method: 'POST',
          data: { document_requirement: vm.documentRequirement },
          headers: {
            'Authorization': `Token token=${sessionService.getAuthToken()}`
          }
        });

        documentUpload.then(response => {
          showDetailState(response);
          Flash.create('success', 'Document requirement successfully created.');
        },
        _ => {
          Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
        });
      }
    }

    function showDetailState(response) {
      var id = response != null ? response.data.document_requirement.id : vm.id;

      if (vm.resourceType == 'vendors') {
        $state.go('application.vms.vendor-document-requirement-detail', { resourceId: vm.resourceId, id: id });
      } else if (vm.resourceType == 'contracts') {
        $state.go('application.vms.contract-document-requirement-detail', { resourceId: vm.resourceId, id: id });
      } else if (vm.resourceType == 'products') {
        $state.go('application.vms.product-document-requirement-detail', { vendorId: vm.vendorId, resourceId: vm.resourceId, id: id });
      } else if (vm.resourceType == 'assessments') {
        $state.go('application.vms.assessment-document-requirement-detail', { resourceId: vm.resourceId, id: id });
      }
    }
  }
})();
